import { render, staticRenderFns } from "./demandes.vue?vue&type=template&id=1f31a89e&"
import script from "./demandes.vue?vue&type=script&lang=js&"
export * from "./demandes.vue?vue&type=script&lang=js&"
import style0 from "./demandes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports